import React, { useEffect } from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const Toast = ({ toast, onDone }) => {
  useEffect(() => {
    if (!toast) return
    const timer = setTimeout(onDone, toast.tone === "error" ? 6000 : 3500)
    return () => clearTimeout(timer)
  }, [toast])

  if (!toast) return null
  const error = toast.tone === "error"

  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[1300] animate-[hb-rise_200ms_ease-out]" role="status">
      <div
        className = {clsx(
          "flex items-center gap-2.5 pl-3 pr-2 py-2 rounded-lg border text-[13px] font-medium bg-white",
          error ? "border-rose-200 text-rose-700" : "border-emerald-200 text-emerald-800"
        )}
      >
        <span className={clsx("inline-grid place-items-center w-[22px] h-[22px] rounded-full text-white text-[11px]", error ? "bg-rose-500" : "bg-emerald-500")}>
          <FontAwesomeIcon icon={error ? "exclamation" : "check"} />
        </span>
        {toast.message}
        <button type="button" onClick={onDone} className="ml-1 w-[22px] h-[22px] rounded text-slate-400 hover:text-slate-700 hover:bg-slate-100">
          <FontAwesomeIcon icon="xmark" className="text-[11px]" />
        </button>
      </div>
    </div>
  )
}

export default Toast
